import { createSelector } from 'reselect'
import { getPackages } from '../getPackages'

export const getPackageWithMinPrice = createSelector(
  getPackages,
  packages => {
    const reducer = packages.reduce((acc, current) => !acc || current.price < acc.price ? current : acc, null)
    if (reducer) {
      return reducer.id
    } else {
      return null
    }
  }
)
